import React, { useEffect, useState } from "react";
import "./Orders.css";
import { getOrder } from "../../services/GetOrdersServices";
import { Col, Row } from "react-bootstrap";
import arrowback from "../../assets/images/png/arrow_back.png";
import { useNavigate } from "react-router-dom";

const Orders = () => {
  const [data, setData] = useState([]);
  const token = localStorage.getItem("token");
  const getOrderDetails = async () => {
    const response = await getOrder(token);
    setData(response);
  };
  const navigate = useNavigate();

  useEffect(() => {
    getOrderDetails();
  }, []);

  return (
    <div className="pb-5 pt-4 bg-light-green">
      <div className="container">
        <h2
          style={{ lineHeight: "46px" }}
          className="ff_heebo fw-bold fs_7xl clr_dark_blue"
        >
          My Orders{" "}
          <span className="clr_dark_green fs_lg"> ({data.length})</span>
        </h2>
        {data && data.length !== 0 ? (
          <div className="px-2">
            {data &&
              data.map((value, index) => (
                <Row key={index} className="pb-3 bg-white p-3 rounded-2 mt-3">
                  <Col className="ps-0" md={8} sm={12}>
                    <Row className="align-items-center height-of-products">
                      <Col lg={5} xl={3} md={4} sm={5}>
                        <div className="border-1 border rounded-2 p-1 text-center">
                          {value?.productId?.images?.[0] ? (
                            <img
                              className="order-product-img"
                              src={value?.productId?.images?.[0]}
                              alt="productimage"
                            />
                          ) : (
                            <img
                              className="order-product-img"
                              src={
                                "https://savr-dev-bucket.s3.amazonaws.com/83b1a7b1-728b-4f45-9615-1b7b86b572b4"
                              }
                              alt="productimage"
                            />
                          )}
                        </div>
                      </Col>
                      <Col
                        className="ps-sm-0 mt-3 mt-sm-0 d-flex flex-column justify-content-between h-100"
                        lg={7}
                        xl={9}
                        md={8}
                        sm={7}
                      >
                        <div>
                          <p className="clr_dark_blue_2 fs_md fw-medium ff_heebo mb-0 text-capitalize">
                            {value?.productId?.name}
                          </p>
                          {value?.productId?.productType === "machinery" ? (
                            <p className="clr_dark_grey_5 fs_xsmff_heebo mb-0">
                              Size: medium, Color: blue, Material: Plastic
                            </p>
                          ) : (
                            ""
                          )}
                          <p className="mb-0 clr_dark_grey_5 fs_xsm ff_heebo mb-0">
                            {value?.addressId?.firstName +
                              " " +
                              value?.addressId?.lastName}
                          </p>
                          <p className="mb-0 clr_dark_grey_5 fs_xsm ff_heebo mb-0">
                            {value?.addressId?.streetAddress}
                          </p>
                          <p className="mb-0 clr_dark_grey_5 fs_xsm ff_heebo mb-0">
                            {value?.addressId?.city}({value?.addressId?.pincode}
                            ), {value?.addressId?.state}
                          </p>
                          <div className="d-flex align-items-center gap-3 mt-2">
                            <button className="btn-common-remove-save ff_heebo color_red_2 ff_inter fs_4xsm bg-white py-1 px-2">
                              Return
                            </button>
                            <button className="btn-common-remove-save ff_heebo clr_dark_green ff_inter fs_4xsm bg-white py-1 px-2">
                              Exchange
                            </button>
                          </div>
                        </div>
                        <div className="d-md-none d-flex flex-column gap-1 mt-3">
                          <p className="ff_heebo fw-bold fs_sm clr_dark_blue_2 mb-1">
                            <span className="fw-bold">₹</span>
                            {value?.productId?.discountPrice * value?.quantity}
                          </p>
                          <p className="ff_heebo fw-medium fs_sm clr_dark_blue_2 mb-1">
                            Qty: {value?.quantity}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col className="pe-0 d-none d-md-block" md={4} sm={5}>
                    <div>
                      <p className="ff_heebo fw-bold text-end fs_sm clr_dark_grey_5 mb-1">
                        <span className="fw-bold">₹</span>
                        {value?.total}
                      </p>
                      <p className="ff_heebo fw-medium text-end fs_sm clr_dark_grey_5 mb-1">
                        Qty: {value?.quantity}
                      </p>
                    </div>
                  </Col>
                </Row>
              ))}
          </div>
        ) : (
          <div className="py-5 bg-white rounded-2">
            <div className="py-4">
              <h2 className="text-center">No Orders found</h2>
              <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-sm-5 gap-1">
                <button
                  onClick={() => navigate("/farmer-shop")}
                  className="d-flex align-items-center gap-2 justify-content-center mt-3 btn-common-remove-save py-2 px-3"
                >
                  <img
                    style={{ width: "18px", height1: "18px" }}
                    src={arrowback}
                    alt="backarrow"
                  />
                  <p className="mb-0 clr_dark_green fw-medium">Shop Products</p>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Orders;
